import React from 'react'

export const Info = () => {
  return (
    <div>Info</div>
  )
}
